// Fichier : /texts/BadgeNouveau.jsx

import React from 'react';
import styles from './BadgeNouveau.module.css';

const BadgeNouveau = ({ text = 'NOUVEAU', className, cliquable = true }) => {
  // On prépare la liste des classes
  let finalClasses = `${styles.badge} ${className || ''}`;

  if (cliquable) {
    finalClasses += ` ${styles.cliquable}`;
  }

  return (
    <span className={finalClasses}>
      {text}
    </span>
  );
};

export default BadgeNouveau;